import { html } from "../helpers/webComponents";

export class NotepadComponent extends HTMLElement {
    private _noteContent: string = "";
    private _visible: boolean = false;

    private _notepadContainer: HTMLElement | null = null;

    public constructor() {
        super();
        this.attachShadow({ mode: "open" });
    }

    public connectedCallback(): void {
        this._noteContent = localStorage.getItem("notepadContent") || "";
        this.render();
        this.addEventListeners();
    }

    private addEventListeners(): void {
        this.shadowRoot!.querySelector("textarea")!.addEventListener("input", (event: Event) => {
            // eslint-disable-next-line @typescript-eslint/typedef
            const target = event.target as HTMLTextAreaElement;
            this._noteContent = target.value;
            localStorage.setItem("notepadContent", this._noteContent);
        });

        this.shadowRoot!.querySelector(".close-btn")!.addEventListener("click", () => {
            this.toggleVisibility();
        });
    }

    public toggleVisibility(): void {
        this._visible = !this._visible;

        if (this._visible) {
            this._notepadContainer!.classList.remove("closed");
        }
        else {
            this._notepadContainer!.classList.add("closed");
        }
    }

    private render(): void {
        const button: HTMLElement = html`
            <button class="notitieblok">
                Notitieblok
            </button>
        `;

        button.addEventListener("click", () => this.toggleVisibility());

        this.shadowRoot!.innerHTML = `
            <style>
                :host {
                    position: fixed;
                    top: 10px;
                    right: 10px;
                    width: 250px;
                    background: #0000FF;
                    border-radius: 5px;
                    box-shadow: 2px 2px 10px rgba(0,0,0,0.2);
                }
                .notepad-container.closed {
                    display: none;
                }
                .notepad-container {
                    display: flex;
                    flex-direction: column;
                    padding: 10px;
                    border: 2px solid #000;
                }
                .notepad-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }
                .close-btn {
                    cursor: pointer;
                    background: red;
                    color: white;
                    border: none;
                    padding: 5px;
                    font-size: 14px;
                    border-radius: 3px;
                }
                textarea {
                    width: 90%;
                    height: 150px;
                    padding: 10px;
                    font-size: 14px;
                    border: none;
                    outline: none;
                    resize: none;
                    background: #fff;
                }
                .notitieblok {
                    position: fixed;
                    top: 10px;
                    right: 270px;
                    padding: 10px;
                    background: rgb(0, 123, 255);
                    color: white;
                    border: none;
                    cursor: pointer;
                }
            </style>
            <div class="notepad-container closed">
                <div class="notepad-header">
                    <h4>Notitieblok</h4>
                    <button class="close-btn">X</button>
                </div>
                <textarea>${this._noteContent}</textarea>
            </div>
        `;

        this._notepadContainer = this.shadowRoot!.querySelector("div.notepad-container");

        this.shadowRoot!.append(button);
    }
}
